var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
// @todo Move this to runtime.
export var Mark = function Mark() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$static = _ref.static,
    isStatic = _ref$static === void 0 ? false : _ref$static;
  return function (options) {
    var width = options.width,
      height = options.height,
      depth = options.depth,
      paddingLeft = options.paddingLeft,
      paddingRight = options.paddingRight,
      paddingTop = options.paddingTop,
      paddingBottom = options.paddingBottom,
      padding = options.padding,
      inset = options.inset,
      insetLeft = options.insetLeft,
      insetTop = options.insetTop,
      insetRight = options.insetRight,
      insetBottom = options.insetBottom,
      margin = options.margin,
      marginLeft = options.marginLeft,
      marginBottom = options.marginBottom,
      marginTop = options.marginTop,
      marginRight = options.marginRight,
      data = options.data,
      coordinate = options.coordinate,
      theme = options.theme,
      component = options.component,
      interaction = options.interaction,
      x = options.x,
      y = options.y,
      z = options.z,
      key = options.key,
      frame = options.frame,
      labelTransform = options.labelTransform,
      parentKey = options.parentKey,
      clip = options.clip,
      viewStyle = options.viewStyle,
      title = options.title,
      mark = __rest(options, ["width", "height", "depth", "paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "padding", "inset", "insetLeft", "insetTop", "insetRight", "insetBottom", "margin", "marginLeft", "marginBottom", "marginTop", "marginRight", "data", "coordinate", "theme", "component", "interaction", "x", "y", "z", "key", "frame", "labelTransform", "parentKey", "clip", "viewStyle", "title"]);
    return [Object.assign(Object.assign({
      type: 'standardView',
      x: x,
      y: y,
      z: z,
      key: key,
      width: width,
      height: height,
      depth: depth,
      padding: padding,
      paddingLeft: paddingLeft,
      paddingRight: paddingRight,
      paddingTop: paddingTop,
      inset: inset,
      insetLeft: insetLeft,
      insetTop: insetTop,
      insetRight: insetRight,
      insetBottom: insetBottom,
      paddingBottom: paddingBottom,
      theme: theme,
      coordinate: coordinate,
      component: component,
      interaction: interaction,
      frame: frame,
      labelTransform: labelTransform,
      margin: margin,
      marginLeft: marginLeft,
      marginBottom: marginBottom,
      marginTop: marginTop,
      marginRight: marginRight,
      parentKey: parentKey,
      clip: clip,
      style: viewStyle
    }, !isStatic && {
      title: title
    }), {
      marks: [Object.assign(Object.assign(Object.assign({}, mark), {
        key: "".concat(key, "-0"),
        data: data
      }), isStatic && {
        title: title
      })]
    })];
  };
};
Mark.props = {};